<template>
    <div class="py-4">
        <h1 class="text-center">333333</h1>
        <div class="d-flex justify-content-center" style="height: 1500px;">
            <p class="align-content-center">
                tttttttttttttttttttttttttttttttttt
            </p>
        </div>
    </div>
</template>
<script>
import Nav from './comment/nav.vue'
import Footer from './comment/footer.vue'
export default {
    components: { Nav,Footer },
}
</script>
<style lang="">
    
</style>